export default "__VITE_ASSET__92efd1a2__"